import { fetchProducts, fetchData, createCheckout, sendForm, sendNewsletter } from './api'

export default {
  async FETCH_PRODUCTS({ commit }) {
    await fetchProducts().then(products => commit('SET_PRODUCTS', { products }))
  },

  async FETCH_DATA({ commit }, url) {
    await fetchData(url).then(data => commit('SET_DATA', data))
  },

  TRIGGER_MENU({ commit, state }, bool) {
    const trigger = (bool !== undefined) ? bool : !state.isMenuOpen
    commit('MENU_TRIGGER', { trigger })
  },

  TRIGGER_CART({ commit, state }, bool) {
    const trigger = (bool !== undefined) ? bool : !state.isCartOpen
    commit('CART_TRIGGER', { trigger })
  },

  async SEND_FORM({}, data) {
    return sendForm(data)
  },

  async CHECKOUT_CART({ commit }) {
    const checkout = await createCheckout()
    commit('SET_CHECKOUT', checkout)
    return new Promise(resolve => resolve(checkout))
  },

  SET_SMOOTH({ commit }, smooth) {
    return commit('SET_SMOOTH', { smooth })
  },

  async SEND_NEWSLETTER({}, data) {
    return sendNewsletter(data)
  },


}



// WEBPACK FOOTER //
// ./src/store/actions.js